// extracted by mini-css-extract-plugin
export default {"formBtn":"buttons_formBtn__0m0VF","btn":"buttons_btn__wUPIO"};